import {Injectable} from '@angular/core';
import {ILaunchpadConfig} from "../interface/launchpad-config.interface";
import {ILaunchpadProvider} from "../interface/launchpad-provider.interface";

/**
 * Registry service for module-specific launchpad providers.
 * Each module registers its launchpad provider during module initialization.
 *
 * Usage:
 *   constructor(private registry: LaunchpadRegistryService) {
 *       registry.register(new BmLaunchpadProvider());
 *   }
 */
@Injectable({
    providedIn: 'root'
})
export class LaunchpadRegistryService {

    private providers = new Map<string, ILaunchpadProvider>();

    register(provider: ILaunchpadProvider): void {
        const config = provider.getConfig();
        this.providers.set(config.moduleAlias, provider);
    }

    getProvider(moduleAlias: string): ILaunchpadProvider | undefined {
        return this.providers.get(moduleAlias);
    }

    getConfig(moduleAlias: string): ILaunchpadConfig | undefined {
        const provider = this.providers.get(moduleAlias);
        return provider ? provider.getConfig() : undefined;
    }

    getRegisteredModules(): string[] {
        return Array.from(this.providers.keys());
    }

    hasModule(moduleAlias: string): boolean {
        return this.providers.has(moduleAlias);
    }
}
